module.exports = __webpack_public_path__ + "img/mini-logo.2647c556.svg";